import { SalesForceTokens } from '@treatwell/ui/dist/types/src/hooks/useSalesforceBot/types';
import { httpPostJson } from '@treatwell/ui';

type Tokens = {
  profileAccessToken: string;
  chatSessionToken: string;
};

export const tokenProviders = {
  getAccessToken: async function (): Promise<string> {
    const tokens = await getTokens();
    return tokens.chatSessionToken;
  },
  getProfileAccessToken: async function (): Promise<string> {
    const tokens = await getTokens();
    return tokens.profileAccessToken;
  },
};

function ensureTokens(tokens: Tokens | null): Tokens {
  if (tokens == null) {
    throw new Error('No token provided');
  }
  return tokens;
}

const getTokens = async (): Promise<Tokens> => {
  const path = Wahanda.Features.isEnabled('CD-1586-salesforce-bot-getting-tokens-with-venue-id')
    ? App.Api.wsUrl(`/venue/${App.getVenueId()}/salesforce/chat-token`)
    : App.Api.wsUrl('/salesforce/chat-token');

  try {
    return ensureTokens(
      await httpPostJson<SalesForceTokens | null>({ path }),
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};
